<template>
	<div class="address">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1rem" @click="back" />
			<span>地址管理</span>
			<div></div>
		</div>
		<Address></Address>
	</div>
</template>

<script>
	import Address from '@/components/location'
	
	export default {
		data() {
			return {

			}
		},
		components: {
			Address
		},
	}
</script>

<style scoped>
	.address {
		padding-top: 2rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/min/site.vue